import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ThemeService {
  private readonly key = "theme";

  setTheme(theme: "default" | "black-theme" | "blue-theme") {
    document.documentElement.classList.remove("black-theme", "blue-theme");

    if (theme !== "default") {
      document.documentElement.classList.add(theme);
    }

    localStorage.setItem(this.key, theme);
  }

  loadSavedTheme() {
    const saved = localStorage.getItem(this.key);

    if (saved === "black-theme" || saved === "blue-theme") {
      this.setTheme(saved);
    } else {
      this.setTheme("default");
    }
  }
}
